/**
 * LoadingScreen - Minimal loading screen for initial config fetch
 */

export default function LoadingScreen({ message = "Loading portfolio..." }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-cyan-50 flex items-center justify-center">
      <div className="text-center space-y-6">
        {/* Animated logo/icon */}
        <div className="relative">
          <div className="w-16 h-16 mx-auto">
            <div className="absolute inset-0 rounded-full border-4 border-emerald-200"></div>
            <div className="absolute inset-0 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin"></div>
          </div>
        </div>
        
        {/* Loading text */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">Rohan Kumar</h1>
          <p className="text-gray-600 font-medium">{message}</p>
        </div>
        
        {/* Progress dots */}
        <div className="flex justify-center space-x-1">
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}